import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "editor", "nameInput", "colorSelect"]
  static values = {
    topicId: String,
    topicName: String,
    topicColor: String,
    domainUuid: String
  }

  connect() {
    this.boundCloseOnOutsideClick = this.closeOnOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundCloseOnOutsideClick)
  }

  showEditor(event) {
    event.preventDefault()
    event.stopPropagation()
    
    this.displayTarget.classList.add("hidden")
    this.editorTarget.classList.remove("hidden")
    this.syncColorSelection()
    
    if (this.hasNameInputTarget) {
      this.nameInputTarget.focus()
      this.nameInputTarget.select()
    }
    
    setTimeout(() => {
      document.addEventListener("click", this.boundCloseOnOutsideClick)
    }, 0)
  }

  closeEditor(event) {
    if (event) {
      event.preventDefault()
    }
    
    this.displayTarget.classList.remove("hidden")
    this.editorTarget.classList.add("hidden")
    
    document.removeEventListener("click", this.boundCloseOnOutsideClick)
    
    // Reset form
    if (this.hasNameInputTarget) {
      this.nameInputTarget.value = this.topicNameValue
    }
    this.syncColorSelection()
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.closeEditor()
    }
  }

  save(event) {
    event.preventDefault()
    
    const form = event.target.closest("form")
    if (form) {
      document.removeEventListener("click", this.boundCloseOnOutsideClick)
      form.requestSubmit()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.closeEditor(event)
    } else if (event.key === "Enter" && event.target === this.nameInputTarget) {
      this.save(event)
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  syncColorSelection() {
    if (!this.hasColorSelectTarget) return

    const targetColor = this.topicColorValue
    this.colorSelectTargets.forEach((input, index) => {
      if (targetColor) {
        input.checked = input.value === targetColor
      } else {
        input.checked = index === 0
      }
    })
  }
}
